import { chunk } from 'lodash';

export const dataSplitting = (data, splitter) => chunk(data, splitter);
